import { BlogArticleTemplate } from './BlogArticleTemplate';

export function BlogArticleDemo() {
  const metadata = {
    category: 'Mental Control',
    categorySlug: 'mental-control-overthinking',
    title: 'Article Title Placeholder',
    author: 'Author Name',
    publishedDate: '2024-01-15',
    readingTime: '8 min',
    featuredImage: {
      url: 'https://images.unsplash.com/photo-1499750310107-5fef28a66643?w=1200&h=675&fit=crop',
      alt: 'Article featured image description'
    }
  };

  const faqItems = [
    {
      question: 'What is overthinking?',
      answer: 'Overthinking is the repetitive mental activity where thoughts cycle without resolution or forward progress. It differs from productive thinking by lacking clear boundaries or actionable endpoints.'
    },
    {
      question: 'What is rumination?',
      answer: 'Rumination is a specific pattern of overthinking focused on past events or negative emotions, characterized by repetitive analysis without problem-solving intent or outcome.'
    },
    {
      question: 'How do you stop mental loops?',
      answer: 'Mental loops are interrupted through structured cognitive boundaries—predetermined stopping points that redirect mental energy rather than suppress it. This requires a systematic framework, not willpower alone.'
    }
  ];

  const relatedArticles = [
    {
      title: 'Why High-Performers Struggle With Overthinking',
      excerpt: 'Analytical minds are built to solve problems. But modern life rarely provides clear endpoints for thinking.',
      thumbnail: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=400&h=225&fit=crop',
      slug: 'why-high-performers-struggle-overthinking',
      category: 'Mental Control'
    },
    {
      title: 'The Difference Between Rumination and Reflection',
      excerpt: 'One builds insight. The other burns energy. Understanding the distinction is the first step toward control.',
      thumbnail: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=225&fit=crop',
      slug: 'rumination-vs-reflection',
      category: 'Mental Control'
    },
    {
      title: 'Mental Boundaries: What They Are and Why You Need Them',
      excerpt: 'Without boundaries, your mind treats every thought as equally urgent. Structure changes that default.',
      thumbnail: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=225&fit=crop',
      slug: 'mental-boundaries-explained',
      category: 'Structured Thinking'
    }
  ];

  return (
    <BlogArticleTemplate
      metadata={metadata}
      faqItems={faqItems}
      relatedArticles={relatedArticles}
    >
      {/* Article content goes here - this is just the structure demonstration */}
      
      <h2>Section Heading Example</h2>
      <p>
        This is a paragraph example demonstrating the clean typography and optimal line height for readability. 
        The content area is centered with a maximum width between 720-820px for comfortable reading.
      </p>
      
      <h3>Subsection Heading Example</h3>
      <p>
        Clear hierarchy between H2 and H3 elements ensures proper content structure for both SEO and readability. 
        All headings follow semantic HTML5 standards.
      </p>

      <ul>
        <li>Bullet point example for clean list styling</li>
        <li>Minimal design with clear visual hierarchy</li>
        <li>Optimized spacing and contrast</li>
      </ul>

      <blockquote>
        This is a blockquote example with subtle but visible styling that maintains the analytical tone 
        while providing visual distinction from regular paragraphs.
      </blockquote>

      <h2>Another Major Section</h2>
      <p>
        Content continues with consistent spacing and typography. The template maintains strong readability 
        across all devices while optimizing for Core Web Vitals and fast loading times.
      </p>

      <h3>Implementation Details</h3>
      <p>
        The template uses semantic HTML5 structure with proper article, section, header, and nav elements. 
        This ensures optimal indexing by both search engines and LLM systems.
      </p>

      <ol>
        <li>Numbered list example for sequential information</li>
        <li>Clear visual distinction from unordered lists</li>
        <li>Maintains minimal, analytical design approach</li>
      </ol>
    </BlogArticleTemplate>
  );
}
